
import React, { useState, useRef } from 'react';
import Axios from "../../api/axios";
import DataGrid, {
    FilterRow, Toolbar,
    ColumnChooser, ColumnFixing, Column, LoadPanel, GroupPanel, Paging, Pager,
    Scrolling, HeaderFilter, Selection, SearchPanel
} from '../BootstrapDataGrid';
import Dict from "../../messages.js";
import * as utl from '../../utils/utils.js';
import * as glb from "../../globals.js";

function getSearchItemsByRights() {
    const atamaYetki = [];
    atamaYetki.push({ value: '3', text: Dict.get('Bana Atananlar') });
    atamaYetki.push({ value: '2', text: Dict.get('Kendi Olusturduklarim') });
    if (utl.hasRight('TumKayitlar') || glb.default.KULLANICI.KUL_YETKI === 0) {
        atamaYetki.push({ value: '1', text: Dict.get('Tüm Kayıtlar') });
    }
    if (utl.hasRight('AtadiklarimiGor') || glb.default.KULLANICI.KUL_YETKI === 0) {
        atamaYetki.push({ value: '4', text: Dict.get('Atadıklarım') });
    }
    return atamaYetki;
}


const CariBulPanel = ({ onAraSecildi }) => {
    const [searchKey, setSearchKey] = useState('');
    const [degerlendirmeFiltresi, setDegerlendirmeFiltresi] = useState(null);
    const [durumFiltresi, setDurumFiltresi] = useState(null);
    const [atamaFiltresi, setAtamaFiltresi] = useState('1');
    const [activeRow, setActiveRow] = useState({ CAR_REF: 0, CAR_SIL: null, CAR_ADSOY: null });
    const listFormGrid = useRef(null);

    // CustomStore for backend paging/filtering/sorting
    const listFormGridDS = React.useMemo(() => ({
        key: 'CAR_REF',
        load: async (loadOptions) => {
            const params = {
                skip: loadOptions.skip,
                take: loadOptions.take,
                sort: loadOptions.sort ? JSON.stringify(loadOptions.sort) : '',
                filter: loadOptions.filter ? JSON.stringify(loadOptions.filter) : '',
                st: atamaFiltresi,
                sk: searchKey,
                cid: glb.default?.KULLANICI?.KUL_DEF_FIR_REF,
                kulid: glb.default?.KULLANICI?.KUL_REF,
                deg: degerlendirmeFiltresi || '',
                drm: durumFiltresi || ''
            };
            // Liste araması her zaman sunucu — cache yalnızca cari detay panelleri içindir.
            const res = await Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}CARI_KART/lst`, { params });
            const payload = res.data || {};
            if (payload.data && payload.data.length > 0) setActiveRow(payload.data[0]);
            else setActiveRow({ CAR_REF: 0, CAR_SIL: null, CAR_ADSOY: null });
            return {
                data: payload.data || [],
                totalCount: payload.totalCount || 0
            };
        }
    }), [atamaFiltresi, searchKey, degerlendirmeFiltresi, durumFiltresi]);

    const onRowDblClick = (e) => {
        if (e && e.data) {
            onAraSecildi && onAraSecildi(e.data);
        }
    };

    const onListFormGridFocusedRowChanged = (e) => {
        if (e && e.row && e.row.data) {
            setActiveRow(e.row.data);
        }
    };

    return (
        <DataGrid
            className={'context dx-card wide-card'}
            dataSource={listFormGridDS}
            remoteOperations={true}
            showBorders={true}
            allowColumnResizing={true}
            focusedRowEnabled={true}
            hoverStateEnabled={true}
            repaintChangesOnly={true}
            ref={listFormGrid}
            height={'100%'}
            width={'100%'}
            defaultFocusedRowIndex={0}
            columnAutoWidth={true}
            onRowDblClick={onRowDblClick}
            onFocusedRowChanged={onListFormGridFocusedRowChanged}
            onCellClick={(e) => {
                if (e.rowType === 'data') {
                    onRowDblClick(e);
                }
            }}
            autoNavigateToFocusedRow={true}
        >
            <Toolbar
                items={[
                    {
                        location: 'before', locateInMenu: 'auto', widget: 'dxTextBox',
                        options: {
                            value: searchKey,
                            placeholder: Dict.get('Arama Kelimesi Gir'),
                            width: '225',
                            onValueChanged: (e) => setSearchKey(e.value),
                            onKeyDown: (e) => {
                                if (e.event && e.event.key === 'Enter') {
                                    setSearchKey(e.component.option('value'));
                                }
                            }
                        }
                    },
                    {
                        location: 'before', locateInMenu: 'auto', widget: 'dxSelectBox',
                        options: {
                            width: '200',
                            value: atamaFiltresi,
                            displayExpr: "text",
                            valueExpr: "value",
                            placeholder: Dict.get('Hangi Kayıtlar Seç'),
                            items: getSearchItemsByRights(),
                            showClearButton: true,
                            onValueChanged: (e) => setAtamaFiltresi(e.value || '1')
                        }
                    },
                    {
                        location: 'before', locateInMenu: 'auto', widget: 'dxButton', options: {
                            icon: '', hint: Dict.get('Seç'), text: Dict.get('Seç'), type: 'default', onClick: () => {
                                if (activeRow && activeRow.CAR_ADSOY) {
                                    onAraSecildi && onAraSecildi(activeRow);
                                }
                            }
                        }
                    }
                ]}
            />
            <Selection mode="single" selectAllMode="allPages" showCheckBoxesMode={true} />
            <Scrolling useNative={true} />
            <GroupPanel visible={true} />
            <ColumnChooser enabled={true} mode={'select'} />
            <ColumnFixing enabled={false} />
            <LoadPanel enabled={true} />
            <HeaderFilter visible={true} />
            <FilterRow visible={true} applyFilter={'auto'} />
            <Paging defaultPageSize={25} />
            <Pager showPageSizeSelector={true} showInfo={true} />
            <Column dataField="CAR_REF" caption={Dict.get('id')} />
            <Column dataField="ATANAN_KULLANICI" caption="Data Sahibi" />
            <Column 
                dataField="CAR_ADSOY" 
                caption={Dict.get('Ad Soyad')} 
                cellRender={(data) => {
                    const adSoyad = data.data?.CAR_ADSOY || data.displayValue;
                    const atanan = data.data?.ATANAN_KULLANICI;
                    return (
                        <u className="pointer">
                            {adSoyad}
                            {atanan ? ` (${atanan})` : ''}
                        </u>
                    );
                }} 
            />
            <Column dataField="SON_DEG" caption={Dict.get('Son Değerlendirme')} />
            <Column dataField="SON_DURUM" caption={Dict.get('Son Durum')} />
            <Column dataField="CAR_CINSIYET" caption={Dict.get('Cinsiyet')} />
            <Column dataField="CAR_GSM" caption={Dict.get('GSM')} />
            <Column dataField="CAR_TEL1" caption={Dict.get('Telefon1')} />
            <Column dataField="CAR_TEL2" caption={Dict.get('Telefon2')} />
            <Column dataField="ULKE_AD" caption={Dict.get('Ülke')} />
            <Column dataField="CAR_SIL" visible={false} caption={Dict.get('Pasif')} />
        </DataGrid>
    );
};

export default CariBulPanel;
          